module.exports = __webpack_public_path__ + "img/top.f0a5e33d.jpg";